import { render, staticRenderFns } from "./VEmployerHome.vue?vue&type=template&id=9ec55418&scoped=true&lang=pug"
import script from "./VEmployerHome.vue?vue&type=script&lang=ts"
export * from "./VEmployerHome.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerHome.vue?vue&type=style&index=0&id=9ec55418&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec55418",
  null
  
)

/* custom blocks */
import block0 from "./EmployerHome.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FHomeNew%2FVEmployerHome.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports